<script lang="ts">
  import { transformListKey } from '$shared/helpers/ListKeyFormat';
  import { isUrl, middleEllipsis, parseDynamicData } from '$shared/helpers/utils';
  interface Props {
    key: string;
    value: string;
    hide?: boolean;
  }

  let { key, value, hide = false }: Props = $props();
</script>

<div class="table-inner-i" class:hide>
  <div data-cy={`${key}-k`} class="key">{transformListKey(key)}</div>
  <div data-cy={`${key}-v`} class="value">
    {#if isUrl(value)}
      <a class="link" href={value} target="_blank" title={value}>{middleEllipsis(value, 40)}</a>
    {:else}
      {parseDynamicData(value)}
    {/if}
  </div>
</div>

<style>
  .table-inner-i {
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
  }
  .table-inner-i.hide {
    display: none;
  }
  .table-inner-i .key {
    width: 150px;
    margin-right: 16px;
    flex-shrink: 0;
    font-weight: 500;
    color: var(--black);
  }
  .table-inner-i .value {
    text-align: left;
    word-break: break-word;
  }
  .table-inner-i .value .link {
    color: var(--blue);
    text-decoration: none;
  }
</style>
